module.exports = __webpack_public_path__ + "img/comeinto@2x.c13d2835.jpg";